<template>
  <div>
    <p>Finalizing authentication...</p>
  </div>
</template>

<script>
import { useAuthStore } from "../store/auth";
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import api from "../services/api";

export default {
  setup() {
    const authStore = useAuthStore();
    const router = useRouter();

    onMounted(async () => {
      try {
        const params = new URLSearchParams(
          typeof window !== "undefined" ? window.location.search : ""
        );
        const ticket = params.get("ticket");
        if (ticket) {
          const completed = await api.post("/auth/google/complete", { ticket });
          authStore.setUser(completed.data.user);
        }
        const response = await api.get("/api/user");
        authStore.setUser(response.data.user);

        sessionStorage.setItem("newSession", "true");

        if (authStore.user && !authStore.user.race) {
          router.push("/race-selection");
        } else {
          router.push("/game/home");
        }
      } catch (error) {
        console.error("Failed to fetch user after social login:", error);
        if (authStore.user) {
          sessionStorage.setItem("newSession", "true");
          if (!authStore.user.race) {
            router.push("/race-selection");
          } else {
            router.push("/game/home");
          }
          return;
        }
        router.push("/login");
      }
    });

    return {};
  },
};
</script>
